
//const API_ENDPOINT = "https://wobxakvml3.execute-api.eu-west-2.amazonaws.com/prod/";
const API_ENDPOINT = "https://workout2.kassim-slaney.de/apis/";

export async function callBackend(path, method, parameters) {

    // Locate the Cognito access token in local storage
    var i;
    var accessToken = ""

    //console.log("local storage");
    for (i = 0; i < localStorage.length; i++)   {
        //console.log(localStorage.key(i) + "=[" + localStorage.getItem(localStorage.key(i)) + "]");
        if (localStorage.key(i).endsWith("idToken")) {
            accessToken = localStorage.getItem(localStorage.key(i))
        }
    }

    //console.log(accessToken);

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "application/json",
        "Authorization": `${accessToken}`
    }
    var options = {
        method: method,
        headers: headers
    }

    if (method === 'GET') {
        var queryParameters = "?";
        var key;
        for (key in parameters) {
            queryParameters += `${key}=${parameters[key]}&`
        }
        queryParameters = queryParameters.slice(0, -1); // remove trailing &
        console.log(queryParameters);
        path = path + queryParameters;
    } else {
        options.body = JSON.stringify(parameters);
    }
    
    const result = await fetch(
        API_ENDPOINT + path, 
        options
    );
        
    if (!result.ok) {
        throw new Error(`Response status: ${result.status}`);
    }

    const apiResult = await result.json();
    console.log(result);

    return apiResult;
}
